const WARD_LABEL_TO_TYPE = {
  'all wards': 'all_wards',
  icu: 'icu',
  medical: 'medical',
  surgical: 'surgical',
  pediatrics: 'pediatrics',
  maternity: 'maternity',
};

export function resolvePatientWardType(patient) {
  const explicit = String(patient?.wardType || '').toLowerCase().trim();
  if (explicit) {
    return explicit === 'general' ? 'all_wards' : explicit;
  }

  const wardLabel = String(patient?.ward || '').toLowerCase().trim();
  return WARD_LABEL_TO_TYPE[wardLabel] || 'all_wards';
}

export function computeAgeFromDob(dob) {
  if (!dob) return null;
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age;
}

export function createAdmittedPatient({ name, dob, sex, wardType = 'all_wards' }) {
  const id = `p-admit-${Date.now()}`;
  const rawWardType = String(wardType || 'all_wards').toLowerCase();
  const normalizedWardType = rawWardType === 'general' ? 'all_wards' : rawWardType;

  const ward =
    normalizedWardType === 'icu'
      ? 'ICU'
      : normalizedWardType === 'surgical'
        ? 'Surgical'
        : normalizedWardType === 'pediatrics'
          ? 'Pediatrics'
          : normalizedWardType === 'maternity'
            ? 'Maternity'
            : 'Medical';

  return {
    id,
    name,
    nameEn: name,
    dob,
    room: '—',
    ward,
    wardType: normalizedWardType,
    age: computeAgeFromDob(dob),
    sex,
    favorite: false,
    documented: false,
    allergies: [],
    diagnoses: [],
    medications: [],
    recentVitals: null,
    lastNote: null,
    tasks: [],
    isAdmitted: true,
    admittedAt: new Date().toISOString(),
  };
}
